import { CapacityType } from '../../../enums/CapacityType';
import { CapacityPlausibilityCheck } from '../../../enums/CapacityPlausibilityCheck';

export const NUM_OF_MONTH_COLUMNS_FOR_CAPACITY_REPORT = 12;

export const COLUMNS_FOR_CAPACITY_REPORT_EXCEL_TEMPLATE = [
    'Datum',
    'Stadt',
    'Standort Detail',
    'Worktype',
    'Kanal',
    'Task',
    'Capacity Type',
    'Value',
];

// Stable rowGroup discriminators for the Capacity Analysis table. These land in
// the row data and in getRowId, so they must never hold translated text — the
// grid maps them to a label via CAPACITY_ANALYSIS_ROW_GROUP_LABEL_KEYS.
export const CapacityAnalysisRowGroup = {
    PLAN_STATUS: 'planStatus',
    PLAN_STATUS_COMPARISON: 'planStatusComparison',
    DIFFERENCE: '+/-',
};

// The difference group is a symbol, identical in every language, so it has no key.
export const CAPACITY_ANALYSIS_ROW_GROUP_LABEL_KEYS = {
    [CapacityAnalysisRowGroup.PLAN_STATUS]: 'analysis.planStatus',
    [CapacityAnalysisRowGroup.PLAN_STATUS_COMPARISON]: 'analysis.planStatusComparison',
};

// `text` holds an i18n key
export const plausibilityCheckOptions = [
    {
        value: 'all',
        text: 'plausibility.all',
    },
    { value: CapacityPlausibilityCheck.CORRECT, text: 'plausibility.correct' },
    { value: CapacityPlausibilityCheck.WRONG, text: 'plausibility.wrong' },
];

export const CapacityTypesPlausibilityCheck = {
    CUSTOMER_WORKLOAD: {
        mainCapacityType: CapacityType.CUSTOMER_WORKLOAD.name,
        influentialCapacityTypes: [
            { name: CapacityType.CUSTOMER_WORKLOAD.name, variable: 'customerWorkload' },
            { name: CapacityType.ABT.name, variable: 'abt' },
            { name: CapacityType.HANDLED_CONTACTS.name, variable: 'handledContacts' },
        ],
    },
    FTE_PAID_AND_SENIOR_AGENT: {
        mainCapacityType: CapacityType.FTE_PAID_AND_SENIOR_AGENT.name,
        influentialCapacityTypes: [
            {
                name: CapacityType.FTE_PAID_AND_SENIOR_AGENT.name,
                variable: 'ftePaidAndSeniorAgent',
            },
            { name: CapacityType.PAID_TIME.name, variable: 'paidTime' },
        ],
    },
    PAID_TIME: {
        mainCapacityType: CapacityType.PAID_TIME.name,
        influentialCapacityTypes: [
            { name: CapacityType.PAID_TIME.name, variable: 'paidTime' },
            { name: CapacityType.PLANNED_ABSENCE.name, variable: 'plannedAbsence' },
            { name: CapacityType.UNPLANNED_ABSENCE.name, variable: 'unplannedAbsence' },
            { name: CapacityType.TRAINING.name, variable: 'training' },
            { name: CapacityType.OTHER_UNPRODUCTIVITY.name, variable: 'otherUnproductivity' },
            { name: CapacityType.AVAILABLE_TIME.name, variable: 'availableTime' },
            { name: CapacityType.CUSTOMER_WORKLOAD.name, variable: 'customerWorkload' },
        ],
    },
};
